/**
 * validates the supplied url
 *
 * @param url string to be validated
 */
export const validateURL = (url: string) => {
  try {
    return new URL(url).toString()
  } catch (err) {
    throw new Error(`Failed to parse '${url}'. Is it a valid URL?`)
  }
}
